<template>
  <div class="home-container">
    <div class="home-page" v-show="type === 'home'">
      <div class="upload-area">
        <el-upload v-for="(item,index) in fileNumber" :key="item" class="upload-demo" drag
                   :data="{type:item,srcDoc:uploadSrc[index]}" :on-change="uploadChange" action=""
                   :http-request="uploadSectionFile" :before-upload="beforeUploadFile"
                   :on-exceed="handleExceed" :multiple="false" :limit="3" list-type="text"
                   :show-file-list="false" :file-list="fileArr"
                   :accept="supportFileSuffixList.map(i => '.' + i).join(',')">
          <img :src="require('@/assets/imgs/alignment-icons/upload.png')" alt="">
          <div class="el-upload__text">拖入或点击 <em style="border-bottom: 1px solid">上传文件</em></div>
        </el-upload>
      </div>
      <div class="upload-tips">
        <p>文件大小不超过20M</p>
        <p>
          支持（docx、doc、txt、pdf、xlsx、xls、pptx、ppt、rtf、html、htm、xlf、odt、pot）格式文件</p>
      </div>
      <div class="introduce">
        <p class="title">飞译双语对齐工具</p>
        <div class="line"></div>
        <div class="present">
          <div v-for="(item,index) in introduce" :key="index" class="present-item">
            <div class="img-area">
              <img :src="item.imgSrc" alt="">
            </div>
            <div class="text-area">
              <p class="present-title">{{ item.title }}</p>
              <p class="present-text">{{ item.present }}</p>
            </div>
            <div class="index"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="editor-head" v-show="type === 'editor'">
      <div class="upload-area">
        <!--        点击上传-->
        <div v-show="!fileInfo">
          <el-upload class="upload-demo" :data="{type:srcDoc === 'source'?1:2}"
                     :on-change="uploadChange" action="" :http-request="uploadSectionFile"
                     :before-upload="beforeUploadFile" :on-exceed="handleExceed" :multiple="false"
                     :limit="3" list-type="text" :show-file-list="false" :file-list="fileArr"
                     :accept="supportFileSuffixList.map(i => '.' + i).join(',')">
            <el-button class="upload-btn">点击上传</el-button>
          </el-upload>
        </div>
        <!--        重新上传-->
        <div class="show-file-info" v-show="fileInfo && srcDoc === fileInfo.uploadType">
          <el-tooltip class="item" effect="dark" :content="fileInfo ? fileInfo.name : ''"
                      placement="top">
            <span class="file-name">{{ fileInfo ? fileInfo.name : '' }}</span>
          </el-tooltip>
          <template v-if="!isdisableStartAlignment">
            <el-upload class="upload-demo" :data="{type:srcDoc === 'source'?1:2}"
                       :on-change="uploadChange" action="" :http-request="uploadSectionFile"
                       :before-upload="beforeUploadFile" :on-exceed="handleExceed" multiple
                       :limit="3" list-type="text" :show-file-list="false" :file-list="fileArr"
                       :accept="supportFileSuffixList.map(i => '.' + i).join(',')">
              <button class="re-upload" @click="resetUpload">重新上传</button>
            </el-upload>

            <span style="color: #CB2634" v-if="fileInfo && fileInfo.status === 'error'"><img
                   class="upload-error"
                   :src="require('@/assets/imgs/alignment-icons/upload-error.png')"
                   alt="" />解析失败</span>
            <el-progress v-else :percentage="fileInfo?fileInfo.percentage:0"></el-progress>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";
import bilingualAlignmentAjax from "@/services/bilingualAlignment"
export default {
  name: "notLogin",
  props: ["type", "srcDoc"],
  data() {
    return {
      isdisableStartAlignment: false,
      uploadSrc: ['source', 'target'],//区分双文档
      filePathList: [],//文件地址列表
      fileArr: [],//文件列表
      host: "",//上传文件地址
      fileInfo: null,//文件信息
      formData: null,
      supportFileSuffixList: ["docx", "doc", "txt", "pdf", "xlsx", "xls", "pptx", "ppt", "rtf", "html", "htm", "xlf", "odt", "pot"],//支持格式
      uploadType: '',//区分双文档
      timer: null,
      introduce: [
        {
          imgSrc: require("@/assets/imgs/alignment-icons/home-page1.png"),
          title: "全面",
          present: "丰富格式与多语种支持",
        },
        {
          imgSrc: require("@/assets/imgs/alignment-icons/home-page3.png"),
          title: "迅捷",
          present: "一键去重筛选，快速定位",
        },
        {
          imgSrc: require("@/assets/imgs/alignment-icons/home-page2.png"),
          title: "智能",
          present: "智能算法高效对齐",
        },
        {
          imgSrc: require("@/assets/imgs/alignment-icons/home-page4.png"),
          title: "高效",
          present: "语料积累提高翻译效率",
        },
      ]
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.layout.userInfo,
      fileNumber: state => state.alignment.fileNumber,
      fileList: state => state.alignment.fileList,
    }),
  },
  watch: {
    fileArr: {
      handler(data) {
        if (!data || !data.length) {
          sessionStorage.removeItem("myFileList")
          sessionStorage.removeItem("sourceLang")
          sessionStorage.removeItem("targetLang")
          sessionStorage.removeItem("aligmentqueryInfo")
          sessionStorage.removeItem("isSent")
          sessionStorage.removeItem("myCurrentPage")
          sessionStorage.removeItem("myCurrentRows")
        }
      },
      deep: true
    },
    "$store.getters.fileList": {
      handler(data) {
        if (!data) {
          Object.assign(this.$data, this.$options.data.call(this))
        } else {
          if (data && data.length) {
            this.fileInfo = null
            data.forEach(item => {
              if (item.uploadType === this.srcDoc) {
                this.fileInfo = item
              }
            })
          }
          this.fileArr = data
        }
      },
      immediate: true
    },
  },
  created() {
    //获取文件信息并初始化
    this.fileArr = this.fileList || []
    if (this.fileList && this.fileList.length) {
      this.fileList.forEach(item => {
        if (item.uploadType === this.srcDoc) {
          this.fileInfo = item
        }
      })
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.isdisableStartAlignment = JSON.parse(sessionStorage.getItem('isdisableStartAlignment')) || false
    })
  },
  methods: {
    //双文档设置
    resetUpload() {
      this.uploadType = this.srcDoc
    },
    // 上传前函数,获取签名等信息
    async uploadSectionFile(param) {
      param.data.type === 1 ? this.uploadType = "source" : this.uploadType = "target"
      if (!this.userInfo) {
        this.$message.warning('请先登录')
        return
      }
      // console.log(param.data.srcDoc, this.fileArr.length)
      if (param.data.srcDoc === "target" && (!this.fileArr || this.fileArr.length === 0)) {
        this.$message.warning('请上传源文件')
        await this.$store.dispatch("saveFileList", null)
        sessionStorage.removeItem("myFileList")
        this.fileArr = []
        return
      }
      if (param.file.obp) {
        return;
      }
      let fileObj = param.file;
      let re = /([^\.\/\\]+)\.([a-z]+)$/i, // 匹配拿到后缀
        resultArr = re.exec(param.file.name);
      let type = resultArr[2];
      let code = localStorage.getItem("myCompanyCode");
      let params = { companyCode: code, fileType: "project" };
      const res = await bilingualAlignmentAjax.getUploadSign(params)
      if (!res.success) {
        return;
      }
      let data = res.result;
      this.host = data.host;
      let key = data.keyPrefix + "." + type;
      delete data.keyPrefix;
      delete data.host;
      this.formData = new FormData();
      this.formData.append("key", key);
      Object.keys(data).forEach((key) => {
        this.formData.append(key, data[key]);
      });
      this.formData.append("file", fileObj);
      this.getFileHost(param);
    },
    //文件上传
    getFileHost(param) {
      let self = this;
      let FileController = self.host;
      let config = {
        onUploadProgress: progressEvent => {
          const complete =
            ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          param.onProgress({ percent: complete });
        }
      };
      axios.post(FileController, self.formData, config).then(function (response) {
        if (!response) {
          return;
        }
        self.filePathList.push(response.data.result);
        self.fileArr.forEach(async (item) => {
          if (item.uid === param.file.uid) {
            item.path = response.data.result.fileName;
            item.status = "success";
            const { result } = await bilingualAlignmentAjax.fileLanguage({ path: item.path })
            if (item.uploadType === "source") {
              //  修改源语言
              self.$store.commit("SET_SOURCE_LANG", result.sourceLang)
              self.$emit("setSourceLang", result.sourceLang)
            } else {
              //  修改目标预言
              self.$store.commit("SET_TARGET_LANG", result.sourceLang)
              self.$emit("setTargetLang", result.sourceLang)
            }
          }
        });
        self.$store.dispatch("saveFileList", self.fileArr)
      }).catch(function (error) {
        self.fileArr.forEach(item => {
          if (item.name === param.file.name) {
            item.exception = "exception";
            item.percentage = 0;
            item.status = "error"
          }
        });
        self.$store.dispatch("saveFileList", self.fileArr)
      });
    },
    //上传方法,设置双文档类型
    uploadChange(event, fileList) {
      event.uploadType = this.uploadType
      this.$store.commit("SAVE_FILE_LIST", event)
      // this.fileArr = Array.from(new Set(this.fileArr))
    },
    //上传前的函数(用于验证上传文件格式及大小)
    beforeUploadFile(file) {
      if (!this.userInfo) {
        this.$message.warning('请先登录')
        this.$store.dispatch("saveFileList", null)
        sessionStorage.removeItem("myFileList")
        this.fileArr = []
        return
      }
      let fileArr = file.name.split(".");
      let regEn = /[*<>|?:\/[\]]/im;
      let type = fileArr[fileArr.length - 1]; // 拿到文件后缀

      const isLt20M = file.size / 1024 / 1024 < 20;

      if (regEn.test(file.name)) {
        this.$message.warning('暂不支持特殊符号')
        file.obp = true;
        return false;
      }
      if (this.supportFileSuffixList.indexOf(type.toLowerCase()) === -1) {
        this.$message.warning(`只支持 ${this.supportFileSuffixList.join("、")} 格式`)
        file.obp = true;
        return false;
      }

      if (file.size < 1) {
        this.$message.warning("不支持上传空文件")
        return false;
      }
      if (!isLt20M) {
        this.$message.warning("上传文件大小不能超过 20MB!")
        file.obp = true;
        return false;
      }
      let arr = [];
      if (this.fileArr.length > 1) {
        arr = this.fileArr.slice(0, -1)
      } else {
        arr = JSON.parse(JSON.stringify(this.fileArr))
      }
      arr.forEach((item, index) => {
        if (item.name === file.name) {
          // this.fileArr.pop()
          this.$store.dispatch("deleteFileList")
          this.$message.warning("上传文件名称重复")
          file.obp = true;
          return false;
        }
      });
      return this.supportFileSuffixList.indexOf(type.toLowerCase()) > -1 && isLt20M;
    },
    // 文件个数超出限制
    handleExceed(files, fileList) {
      this.$message.warning("最多1个文件")
    },
  }
}
</script>

<style scoped lang="scss">
.home-page {
  .upload-area {
    margin-bottom: 40px;
    display: flex;
    padding-top: 56px;
    justify-content: center;
  }

  .upload-tips {
    p {
      line-height: 22px;
      color: #656b74;
      font-size: 14px;
      text-align: center;
    }
  }

  .upload-demo {
    width: 711px;
    height: 258px;
    border: 1px solid #f2f3f5;
    border-radius: 4px;
    margin: 0 39px;
    @media screen and (max-width: 1600px) {
      height: 230px;
    }

    /deep/ .el-upload-dragger,
    /deep/ .el-upload {
      width: 100%;
      height: 100%;

      img {
        margin-top: 40px;
        margin-bottom: 15px;
        @media screen and (max-width: 1600px) {
          margin-top: 20px;
        }
      }
    }

    /deep/ .el-upload-dragger {
      background: #f7f8fa;
      border: none;
    }
  }
}

.upload-error {
  vertical-align: middle;
  margin-left: 12px;
  margin-right: 8px;
}
</style>
<style scoped lang="scss">
.editor-head {
  height: 32px;
  .show-file-info {
    display: flex;
    align-items: center;
    font-size: 14px;

    .file-name {
      display: inline-block;
      color: #0078fc;
      width: 200px;
      line-height: 32px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      @media screen and (max-width: 1600px) {
        width: 150px;
      }
    }

    .re-upload {
      margin-left: 12px;
      cursor: pointer;
      color: #656b74;
      width: 88px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #dfe0e6;
      border-radius: 4px;
    }

    .el-progress {
      width: 100px;
      margin-left: 12px;
    }
  }

  .upload-area {
    display: flex;
    justify-content: space-between;
  }

  .upload-demo {
    display: inline-block;
  }

  .upload-btn {
    width: 88px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #0078fc;
    border-radius: 4px;
    padding: 0;
    color: #0078fc;
  }

  .tips {
    vertical-align: middle;
    margin-left: 12px;
    cursor: pointer;
  }
}
</style>

